import { config } from "./constant";
import { Buffer } from "buffer";
export class Cookie {
  static host = window.location.hostname;

  static set(name: any, value: any, days: any) {
    var domain, domainParts, date: any, expires;

    if (days) {
      date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }

    if (this.host.split(".").length === 1) {
      document.cookie = name + "=" + value + expires + "; path=/";
    } else {
      domainParts = this.host.split(".");
      domainParts.shift();
      domain = domainParts.join(".");
      document.cookie =
        name + "=" + value + expires + "; path=/; domain=" + domain;
    }
  }

  static get = () => {
    return document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce((accumulator, [key, value]) => {
        if (key.trim())
          return { ...accumulator, [key.trim()]: decodeURIComponent(value) };
        else return "";
      }, {});
  };

  static clear = () => {
    const host = window.location.hostname;
    const domainParts = host.split(".");
    domainParts.shift();
    const domain = domainParts.join(".");

    document.cookie =
      "ssoToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" +
      domain;
    document.cookie =
      "roleId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie =
      "stateChange=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" +
      domain;
    document.cookie =
      "userDetials=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" +
      domain;
    document.cookie =
      "workStatus=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" +
      domain;
    document.cookie =
      "userEmail=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" +
      domain;
    document.cookie =
      "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" +
      domain;
    document.cookie =
      "MY_APP_STATE=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" +
      domain;
  };
}

export const getToken = () => {
  return document.cookie
    .split(";")
    .map((cookie) => cookie.split("="))
    .reduce(
      (accumulator, [key, value]) => ({
        ...accumulator,
        [key.trim()]: decodeURIComponent(value),
      }),
      {}
    );
};

export function encryptCodes(content: any, passcode: any) {
  var result: any = [];
  var passLen = passcode.length;
  for (var i = 0; i < content.length; i++) {
    var passOffset = i % passLen;
    var calAscii = content.charCodeAt(i) + passcode.charCodeAt(passOffset);
    result.push(calAscii);
  }
  return JSON.stringify(result);
}

export function decryptCodes(content: any, passcode: any) {
  let result: any = [];
  var str = "";
  var codesArr = JSON.parse(content);
  var passLen = passcode.length;
  for (var i = 0; i < codesArr.length; i++) {
    var passOffset = i % passLen;
    let calAscii: any = codesArr[i] - passcode.charCodeAt(passOffset);
    result.push(calAscii);
  }
  for (var j = 0; j < result.length; j++) {
    var ch = String.fromCharCode(result[j]);
    str += ch;
  }
  return str;
}

export class util {
  static ext(str: string) {
    let re = /(?:\.([^.]+))?$/;
    let op = re.exec(str);
    return op !== null ? op[0] : "";
  }
  static base64_encode(str: any) {
    return new Buffer(str).toString("base64");
  }
  static base64_decode(str: any) {
    return new Buffer(str, "base64").toString();
  }
  static convert_base64 = (url: any, callback: any) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  };
  /*
  util.convert_base64(filename_with_path,function(base64_data){
      setBase64(base64_data);
  });
  */

  static today = (arg = "-") => {
    return new Date()
      .toLocaleString("en-US", { timeZone: config().TIMEZONE })
      .slice(0, 10)
      .split("-")
      .join(arg);
  };

  static datetime = (arg = "-") => {
    return new Date().toLocaleString("en-US", {
      timeZone: config().TIMEZONE,
    });
  };


  static todayfortopup = (arg = "-") => {
    let currentDate = new Date().toLocaleString("en-US", { timeZone: config().TIMEZONE }).slice(0, 10).split('-').join(arg);
    const epochTime = currentDate.valueOf();
    return epochTime;
  }

  static todayDDFirst = (arg = "-") => {
    return new Date().toJSON().slice(0, 10).split("-").reverse().join(arg);
  };

  static ipAddress = (url = "https://api.ipify.org/?format=json") => {
    try {
      return fetch(url).then((res) => res.json().then((k) => k.IPv4));
    } catch {
      return "";
    }
  };

  static getNumeric(value = "") {
    return value.replace(/[^a-zA-Z]/g, "");
  }

  static getNumericWithSpace(value = "") {
    return value.replace(/[^a-zA-Z\s]/g, "");
  }

  static getStringNumber(value = "") {
    return value.replace(/[^a-zA-Z0-9]/g, "");
  }

  static getStringNumberWithSpace(value = "") {
    return value.replace(/[^a-zA-Z0-9\s]/g, "");
  }

  static getNumber(value = "") {
    return value.replace(/\D+/g, "");
  }

  static timestamp() {
    return new Date().getTime();
  }

  static filename(_filename: any) {
    return this.timestamp() + "." + this.ext(_filename);
  }

  static toDataURL = (url: any, callback: any) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  };

  static dataURLtoFile(dataurl: any, filename: any) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  static random(start = 1, end = 10000) {
    return Math.floor(Math.random() * end + start);
  }

  static submitForm(formErrors: any) {
    if (Object.keys(formErrors).length === 0) {
      return false;
    }

    let flag = true;
    Object.keys(formErrors).some((keyName) => {
      if (formErrors[keyName]) {
        flag = false;
      }
      return flag;
    });
    return flag;
  }

  static timestampToMins(timestamp: any) {
    return Math.floor(timestamp / 60000);
  }

  static timestampToHours(timestamp: any) {
    return Math.floor(timestamp / 60 / 60);
  }

  static arrayRemove(array: any) {
    return array.filter(function (el: any) {
      return el != null;
    });
  }

  static getLocalStorage(value: any) {
    if (typeof window != "undefined") {
      return localStorage.getItem(value);
    }
    return "";
  }

  static generate_number() {
    let str = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
    return str
      .split("")
      .sort(function () {
        return 0.5 - Math.random();
      })
      .join("");
  }

  static fileToBase64 = async (url: any) => {
    //console.log("fileToBase64", url);
    return new Promise(function (resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "arraybuffer";
      xhr.send();

      return (xhr.onload = function (e) {
        //console.log("this.status", this.status);
        if (this.status == 200) {
          //console.log("2> " + xhr.response);
          //  console.log("2b> "+ xhr.responseText);

          var uInt8Array = new Uint8Array(this.response);
          var i = uInt8Array.length;
          var biStr = new Array(i);
          while (i--) {
            biStr[i] = String.fromCharCode(uInt8Array[i]);
          }
          var data = biStr.join("");
          var base64 = window.btoa(data);
          resolve(base64);
        }
      });
    });
  };

  static parseJwt = (token: any) => {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };
}
export const timeZoneId = [
  { key: "62", value: "(GMT-12:00) International Date Line West" },
  { key: "61", value: "(GMT-11:00) Midway Island, Samoa" },
  { key: "60", value: "(GMT-10:00) Hawaii" },
  { key: "59", value: "(GMT-09:00) Alaska" },
  { key: "58", value: "(GMT-08:00) Pacific Time (US &amp; Canada)" },
  { key: "63", value: "(GMT-08:00) Tijuana, Baja California" },
  { key: "56", value: "(GMT-07:00) Arizona" },
  { key: "64", value: "(GMT-07:00) Chihuahua, La Paz, Mazatlan" },
  { key: "57", value: "(GMT-07:00) Mountain Time (US &amp; Canada)" },
  { key: "65", value: "(GMT-06:00) Central America" },
  { key: "53", value: "(GMT-06:00) Central Time (US &amp; Canada)" },
  { key: "54", value: "(GMT-06:00) Guadalajara, Mexico City, Monterrey" },
  { key: "55", value: "(GMT-06:00) Saskatchewan" },
  { key: "50", value: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco" },
  { key: "51", value: "(GMT-05:00) Eastern Time (US &amp; Canada)" },
  { key: "52", value: "(GMT-05:00) Indiana (East)" },
  { key: "48", value: "(GMT-04:00) Atlantic Time (Canada)" },
  { key: "66", value: "(GMT-04:30) Caracas" },
  { key: "49", value: "(GMT-04:00) La Paz" },
  { key: "67", value: "(GMT-04:00) Manaus" },
  { key: "68", value: "(GMT-04:00) Santiago" },
  { key: "47", value: "(GMT-03:30) Newfoundland" },
  { key: "45", value: "(GMT-03:00) Brasilia" },
  { key: "69", value: "(GMT-03:00) Buenos Aires" },
  { key: "46", value: "(GMT-03:00) Georgetown" },
  { key: "70", value: "(GMT-03:00) Greenland" },
  { key: "71", value: "(GMT-03:00) Montevideo" },
  { key: "44", value: "(GMT-02:00) Fernando de Noronha" },
  { key: "43", value: "(GMT-01:00) Azores" },
  { key: "72", value: "(GMT-01:00) Cape Verde Is." },
  { key: "1", value: "(GMT+00:00) Casablanca, Monrovia, Reykjavik" },
  { key: "2", value: "(GMT+00:00) Dublin, Edinburgh, Lisbon, London" },
  {
    key: "6",
    value: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  },
  {
    key: "5",
    value: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  },
  { key: "3", value: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris" },
  { key: "4", value: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb" },
  { key: "73", value: "(GMT+01:00) West Central Africa" },
  { key: "74", value: "(GMT+02:00) Amman" },
  { key: "7", value: "(GMT+02:00) Athens, Bucharest, Istanbul" },
  { key: "75", value: "(GMT+02:00) Beirut" },
  { key: "9", value: "(GMT+02:00) Cairo" },
  { key: "88", value: "(GMT+02:00) Damascus" },
  { key: "89", value: "(GMT+02:00) Gaza" },
  { key: "10", value: "(GMT+02:00) Harare, Pretoria" },
  {
    key: "11",
    value: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  },
  { key: "12", value: "(GMT+02:00) Jerusalem" },
  { key: "8", value: "(GMT+02:00) Minsk" },
  { key: "78", value: "(GMT+02:00) Windhoek" },
  { key: "79", value: "(GMT+03:00) Baghdad" },
  { key: "13", value: "(GMT+03:00) Kuwait, Riyadh" },
  { key: "14", value: "(GMT+03:00) Moscow, St. Petersburg, Volgograd" },
  { key: "15", value: "(GMT+03:00) Nairobi" },
  { key: "16", value: "(GMT+03:30) Tehran" },
  { key: "17", value: "(GMT+04:00) Abu Dhabi, Muscat" },
  { key: "81", value: "(GMT+04:00) Baku" },
  { key: "80", value: "(GMT+04:00) Tbilisi" },
  { key: "18", value: "(GMT+04:00) Yerevan" },
  { key: "19", value: "(GMT+04:30) Kabul" },
  { key: "20", value: "(GMT+05:00) Ekaterinburg" },
  { key: "21", value: "(GMT+05:00) Islamabad, Karachi, Tashkent" },
  { key: "22", value: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi" },
  { key: "24", value: "(GMT+05:30) Sri Jayawardenepura" },
  { key: "82", value: "(GMT+05:45) Kathmandu" },
  { key: "23", value: "(GMT+06:00) Astana, Dhaka" },
  { key: "83", value: "(GMT+06:00) Novosibirsk, Omsk" },
  { key: "84", value: "(GMT+06:30) Yangon (Rangoon)" },
  { key: "25", value: "(GMT+07:00) Bangkok, Hanoi, Jakarta" },
  { key: "85", value: "(GMT+07:00) Krasnoyarsk" },
  { key: "26", value: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi" },
  { key: "86", value: "(GMT+08:00) Irkutsk" },
  { key: "28", value: "(GMT+08:00) Kuala Lumpur, Singapore" },
  { key: "27", value: "(GMT+08:00) Perth" },
  { key: "29", value: "(GMT+08:00) Taipei" },
  { key: "90", value: "(GMT+08:00) Ulaan Bataar" },
  { key: "91", value: "(GMT+08:30) Pyongyang" },
  { key: "30", value: "(GMT+09:00) Osaka, Sapporo, Tokyo" },
  { key: "31", value: "(GMT+09:00) Seoul" },
  { key: "32", value: "(GMT+09:00) Yakutsk" },
  { key: "33", value: "(GMT+09:30) Adelaide" },
  { key: "34", value: "(GMT+09:30) Darwin" },
  { key: "35", value: "(GMT+10:00) Brisbane" },
  { key: "36", value: "(GMT+10:00) Canberra, Melbourne, Sydney" },
  { key: "37", value: "(GMT+10:00) Guam, Port Moresby" },
  { key: "38", value: "(GMT+10:00) Hobart" },
  { key: "39", value: "(GMT+10:00) Vladivostok" },
  { key: "76", value: "(GMT+11:00) Magadan" },
  { key: "40", value: "(GMT+11:00) Solomon Is., New Caledonia" },
  { key: "41", value: "(GMT+12:00) Auckland, Wellington" },
  { key: "42", value: "(GMT+12:00) Fiji, Marshall Is." },
  { key: "77", value: "(GMT+12:00) Kamchatka" },
  { key: "87", value: "(GMT+13:00) Nuku'alofa" },
];
export class validator {
  custom(arg0: (value: any) => true | "Card name should only contain alphabetic characters") {
	  throw new Error("Method not implemented.");
  }
  msg = "";
  value = "";
  strong = 0;
  one_numeric = 0;
  one_upper = 0;
  max_8 = 0;
  passwordMatch = 0;
  min: any;
  max: any;

  constructor() {
    this.msg = "";
    this.value = "";
  }
  set(value: any) {
    if (typeof value === "undefined") return this;
    this.msg = "";
    this.value = value;
    return this;
  }
  required(msg: any) {
    msg = this.check(this.value?.trim(), msg);
    if (msg) this.msg = msg;
    return this;
  }
  numeric(msg: any) {
    const regex = new RegExp(/^[0-9\b]+$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  email(msg: any) {
    const regex = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|([\-w]+(?:\.[\-w]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );
    msg = this.check(regex.test(String(this.value.trim()).toLowerCase()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  same(value2: any, msg: any) {
    msg = this.check(this.value.trim() == value2.trim(), msg);
    if (msg) this.msg = msg;
    return this;
  }
  url(msg: any) {
    const regex = new RegExp(
      "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
    );
    msg = this.check(regex.test(String(this.value.trim()).toLowerCase()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  range(min = 1, max = 255, msg: any) {
    msg = this.check(
      parseFloat(this.value.trim()) >= min &&
      parseFloat(this.value.trim()) <= max,
      msg
    );
    if (msg) this.msg = msg;
    return this;
  }
  min_max(min = 1, max = 255, msg: any) {
    msg = this.check(
      this.value.trim().length >= min && this.value.trim().length <= max,
      msg
    );
    if (msg) this.msg = msg;
    return this;
  }
  length(length = 0, msg: any) {
    msg = this.check(this.value.trim().length == length, msg);
    if (msg) this.msg = msg;
    return this;
  }
  alphabet(msg: any) {
    const regex = new RegExp(/[^A-Za-z]/gi);
    msg = this.check(!regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  alphabetWithSpace(msg: any) {
    const regex = new RegExp(/[^A-Za-z\s]/gi);
    msg = this.check(!regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  alphanumeric(msg: any) {
    const regex = new RegExp(/[^A-Za-z]/gi);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  pancard(msg: any) {
    const regex = new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  empid_special_char(msg: any) {
    const regex = new RegExp(/^[-\w\s-_]+$/i);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  special_char(msg: any) {
    const regex = new RegExp(/^[-\w\s-_&']+$/i);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  american_express_card(msg: any) {
    const regex = new RegExp(/^(?:3[47][0-9]{13})$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  visa_card(msg: any) {
    const regex = new RegExp(/^(?:4[0-9]{12}(?:[0-9]{3})?)$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  master_card(msg: any) {
    const regex = new RegExp(/^(?:5[1-5][0-9]{14})$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  discover_card_number(msg: any) {
    const regex = new RegExp(/^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  dinner_club_card(msg: any) {
    const regex = new RegExp(/^(?:3(?:0[0-5]|[68][0-9])[0-9]{11})$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  jcb_card(msg: any) {
    const regex = new RegExp(/^(?:(?:2131|1800|35\d{3})\d{11})$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  cvv(msg: any) {
    const regex = new RegExp(/^[0-9]{3,4}$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  expiry_date(msg: any) {
    //const regex = new RegExp(/(0|1)[0-9]\/(19|20)[0-9]{2}/);
    const regex = new RegExp(/(0|1)[0-9]\/[0-9]{2}/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) {
      this.msg = msg;
      return this;
    } else {
      let date_array: any = this.value.split("/");
      let month = date_array[0] - 1;
      let year = date_array[1];
      let source_date = new Date();
      if (year >= source_date.getFullYear()) {
        if (month >= source_date.getMonth()) {
          this.msg = "";
        } else {
          this.msg = msg;
        }
      } else {
        this.msg = msg;
      }
    }
    return this;
  }
  credit_card(msg: any) {
    const regex = new RegExp("^[0-9]{13,19}$");
    if (!regex.test(this.value.trim())) {
      msg = this.check(false, msg);
      if (msg) this.msg = msg;
      return this;
    } else {
      msg = this.check(this.check_credit_card(this.value.trim()), msg);
      if (msg) this.msg = msg;
      return this;
    }
  }

  check_credit_card(val: any) {
    let checksum = 0; // running checksum total
    let j = 1; // takes value of 1 or 2

    // Process each digit one by one starting from the last
    for (let i = val.length - 1; i >= 0; i--) {
      let calc = 0;
      // Extract the next digit and multiply by 1 or 2 on alternative digits.
      calc = Number(val.charAt(i)) * j;

      // If the result is in two digits add 1 to the checksum total
      if (calc > 9) {
        checksum = checksum + 1;
        calc = calc - 10;
      }

      // Add the units element to the checksum total
      checksum = checksum + calc;

      // Switch the value of j
      if (j == 1) {
        j = 2;
      } else {
        j = 1;
      }
    }

    //Check if it is divisible by 10 or not.
    return checksum % 10 == 0;
  }
  password_numeric(msg: any) {
    const regex = new RegExp(/^(?=.*?[0-9]).{1,}$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    else {
      this.strong++;
      this.one_numeric = 1;
    }
    return this;
  }
  password_upper(msg: any) {
    const regex = new RegExp(/^(?=.*?[A-Z]).{1,}$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    else {
      this.strong++;
      this.one_upper = 1;
    }
    return this;
  }
  password_8(msg: any) {
    //const regex = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/);
    // const regex = new RegExp(/^([A-Za-z0-9]).{7,}$/);
    //const regex = new RegExp(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{8,1000}$/);
    const getMin: any = localStorage.getItem('min_eight_char');
    const minValue = getMin ? parseInt(getMin) : 8;
    const regex = new RegExp(`^(?=.*)[a-zA-Z0-9!@#$%^&*-_=]{${minValue},1000}$`);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    else {
      this.strong++;
      this.max_8 = 1;
    }
    return this;
  }
  password(msg: any) {
    //const regex = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/);
    const regex = new RegExp(/^(?=.*?[A-Z])(?=.*?[0-9]).{8,}$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    else {
      this.strong++;
      this.max_8 = 1;
    }
    return this;
  }
  password_match(msg: any, pass: any, confirmPass: any) {
    if (pass != confirmPass) {
      if (msg) this.msg = msg;
      this.passwordMatch = 1;
    } else {
      this.passwordMatch = 0;
    }
    msg = msg;

    return this;
  }
  pin(msg: any) {
    const regex = new RegExp(/^([0-9]).{5}$/);
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }

  check(value: any, msg: any) {
    if (value) return "";
    else return msg;
  }

  reg_mac_address(msg: any) {
    const regex = new RegExp(
      "^([0-9a-fA-F]{2}(?:(?:-[0-9a-fA-F]{2}){5}|(?::[0-9a-fA-F]{2}){5}|[0-9a-fA-F]{10}))$"
    );
    msg = this.check(regex.test(this.value.trim()), msg);
    if (msg) this.msg = msg;
    return this;
  }
  setMinMax(value: any, min: any, max: any) {
    if (typeof value === "undefined") return this;
    this.msg = "";
    this.value = value;
    this.min = min;
    this.max = max;
    return this;
  }
  minCheck(msg: any) {
    msg = this.check((parseInt(this.value) >= parseInt(this.min)), msg);
    //msg = this.value > 8 ? "" : msg;
    if (msg) this.msg = msg;
    return this;
  }
  maxCheck(msg: any) {
    msg = this.check(parseInt(this.value) <= parseInt(this.max), msg);
    //msg = this.value > 8 ? "" : msg;
    if (msg) this.msg = msg;
    return this;
  }

  userfirstnameCheck(msg: any) {
    const getMessage: any = localStorage.getItem('errormessage')
    const getMessage1: any = JSON.parse(getMessage)
    console.log("getMessage", getMessage1)
    msg = this.check((this.value) !== getMessage1?.fname, msg)
    // if (this.check((this.value) !== getMessage1.fname, msg)) {
    //   msg
    // } else if (this.check((this.value) !== getMessage1.lname, msg)) {
    //   msg
    // } else if (this.check((this.value) !== getMessage1.email, msg)) {
    //   msg
    // }
    console.log("msg", msg)
    if (msg) this.msg = msg;
    return this;
  }

  userlastnameCheck(msg: any) {
    const getMessage: any = localStorage.getItem('errormessage')
    const getMessage1: any = JSON.parse(getMessage)
    console.log("getMessage", getMessage1)
    msg = this.check((this.value) !== getMessage1?.lname, msg)
    console.log("msg", msg)
    if (msg) this.msg = msg;
    return this;
  }

  useremailCheck(msg: any) {
    const getMessage: any = localStorage.getItem('errormessage')
    const getMessage1: any = JSON.parse(getMessage)
    console.log("getMessage", getMessage1)
    msg = this.check((this.value) !== getMessage1?.email, msg)
    console.log("msg", msg)
    if (msg) this.msg = msg;
    return this;
  }

  consecutiveCheck(msg: any) {
    const getMax: any = localStorage.getItem('max_cons_char_allowed');
    const maxValue = getMax ? getMax : 1;
    const consecutivePattern = new RegExp(`(\\w)\\1{${maxValue - 1},}`);  // Matches four or more consecutive characters
    const repeatingPattern = /(\w{1,3})\1+/;  // Matches repeating characters
    msg = this.check(!consecutivePattern.test(this.value), msg);
    if (msg) this.msg = msg;
    return this;
  }

}
